import { render, staticRenderFns } from "./pic_edit.vue?vue&type=template&id=780a28bc&scoped=true"
import script from "./pic_edit.vue?vue&type=script&lang=js"
export * from "./pic_edit.vue?vue&type=script&lang=js"
import style0 from "./pic_edit.vue?vue&type=style&index=0&id=780a28bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a28bc",
  null
  
)

export default component.exports